import { BrandKitAsset, MediaAsset } from "../../types";

export const FONT_SOURCES = {
  BRANDKIT: "brandkit",
  PUBLIC: "public",
  LIBRARY: "library",
} as const;

export const FONT_CATEGORIES = {
  BRANDKIT_FONTS: "brandkitFonts",
  FONT_CATALOG: "fontCatalog",
  LIBRARY_FONTS: "libraryFonts",
} as const;

export interface FontItem {
  font: BrandKitAsset | Partial<MediaAsset>;
  prettyName: string;
  fullName: string;
  key: string;
  source: (typeof FONT_SOURCES)[keyof typeof FONT_SOURCES];
  weight?: string;
  hasName?: boolean;
}

export interface FontFamily {
  familyName: string;
  variants: FontItem[];
  representativeVariant?: FontItem;
}

export interface FontCategory {
  categoryName: string;
  categoryType: string;
  families: FontFamily[];
  icon?: React.ReactNode;
}
